module.exports = __webpack_public_path__ + "static/media/hub-icon.d27b17fc.svg";